if ( typeof LocalizationForm !== 'function' ) {
	class LocalizationForm extends HTMLElement {

		constructor(){

			super();

			this._prefix = window.KT_PREFIX || '';
			this._initialized = false;
			this._populating = false;

		}

		connectedCallback() {
			
			if ( this._initialized ) {
				return;
			}

			if ( document.readyState === 'loading' ) {
				document.addEventListener('DOMContentLoaded', ()=>this.#init(), { once: true });
			} else {
				this.#init();
			}

		}

		#init() {

			if ( this._initialized ) {
				return;
			}
			this._initialized = true;

			this.selector = this.querySelector('[data-js-localization-form-button]');
			this.content = this.querySelector('[data-js-localization-form-content]');

			if ( this.selector ) {

				if ( this.querySelector('[data-js-localization-form-insert-helper-content]') ) {
					
					this.selector.addEventListener('click', e=>{
						if ( ! this._populating && ! this.classList.contains('populated') ) {
							this._populating = true;
							this.#populate();
						}
					})

				}

				this.selector.addEventListener('click', e=>{

					e.stopPropagation();
					e.preventDefault();

					document.querySelectorAll(`[data-js-localization-form-content].${this._prefix}content-opened`).forEach(elm=>{
						if ( elm != e.currentTarget.parentNode.querySelector('[data-js-localization-form-content]') ) {
							elm.classList.remove(`${this._prefix}content-opened`);
							elm.parentNode.style.zIndex = 9;
						}
					});

					if ( ! this.content.classList.contains(`${this._prefix}content-opened`) ) {

						this.content.classList.add(`${this._prefix}content-opened`);
						e.currentTarget.setAttribute('aria-expanded', 'true');
						this.content.parentNode.style.zIndex = 1000;

						this.#position();

						this.onClickHandler = (()=>{
							if ( this.content.classList.contains(`${this._prefix}content-opened`) ) {
								this.content.classList.remove(`${this._prefix}content-opened`, `${this._prefix}invert-x`, `${this._prefix}invert-y`);
								this.content.style.maxWidth = '';
								this.content.parentNode.style.zIndex = 9;
							}
						}).bind(this);
						window.addEventListener('click', this.onClickHandler);

					} else {
						e.currentTarget.setAttribute('aria-expanded', 'false');
						this.content.parentNode.style.zIndex = 9;
						this.content.classList.remove(`${this._prefix}content-opened`, `${this._prefix}invert-x`, `${this._prefix}invert-y`);
						this.content.style.maxWidth = '';
						window.removeEventListener('click', this.onClickHandler);
					}

				});

				this.querySelector('[data-js-localization-form-button]').addEventListener('keydown', e=>{
					if ( e.keyCode == window.KEYCODES.RETURN ) {
						if ( ! this.content.classList.contains(`${this._prefix}opened-with-tab`) ) {
							this.content.classList.add(`${this._prefix}opened-with-tab`);
							this.content.querySelectorAll('[data-js-localization-form-item]').forEach(elm=>{elm.setAttribute('tabindex', '0')});
						}
					}
				});

			}

		}

		disconnectedCallback() {
			if ( this.onClickHandler ) {
				window.removeEventListener('click', this.onClickHandler);
			}
		}

		#position() {

			this.content.style.maxWidth = '';

			if ( this.content.getBoundingClientRect().y + this.content.offsetHeight + 55 > window.innerHeight ) {
				this.content.classList.add(`${this._prefix}invert-y`);
			}
			if ( this.content.getBoundingClientRect().x + this.content.offsetWidth + 55 > window.innerWidth ) {
				this.content.classList.add(`${this._prefix}invert-x`);
			}

			const inverted = this.content.getBoundingClientRect();

			if ( inverted.left < 0 || inverted.right > window.innerWidth ) {

				this.content.classList.remove(`${this._prefix}invert-x`);

				const reverted = this.content.getBoundingClientRect();

				if ( reverted.right > window.innerWidth ) {
					this.content.style.maxWidth = `${window.innerWidth - reverted.left - 12}px`;
				} else if ( reverted.left < 0 ) {
					this.content.style.maxWidth = `${reverted.right - 12}px`;
				}

			}

		}

		#populate() {
			fetch('?section_id=helper-localization-form').then(response=>response.text())
				.then(text => {
					const results = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-helper-localization-form').innerHTML;
					this.querySelector('[data-js-localization-form-insert-helper-content]').innerHTML = results;
					this.classList.add('populated');
					this.#position();
				})
				.catch(e=>{
					console.log(e);
				})
				.finally(()=>{
					this._populating = false;
				})
		}

	}

	if ( typeof customElements.get('localization-form') == 'undefined' ) {
		customElements.define('localization-form', LocalizationForm);
	}

}